<svg width="443" height="275" viewBox="0 0 443 275" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M443 275H0V0H443V275ZM73 46C66.3726 46 61 51.3726 61 58V216C61 222.627 66.3726 228 73 228H370C376.627 228 382 222.627 382 216V81C382 74.3726 376.627 69 370 69H129.29C124.552 69 120.258 66.2123 118.329 61.8848L114.421 53.1152C112.492 48.7877 108.198 46 103.46 46H73Z" fill="black"/>
</svg>
